import axios from 'axios';

import {API_URL, getContentType} from './api.config';
import {deduplicateGetRequests} from './get-request-deduplicator';

const axiosInstanceV1 = axios.create({
  baseURL: API_URL,
  headers: getContentType(),
  withCredentials: true,
});

deduplicateGetRequests(axiosInstanceV1);

export default axiosInstanceV1;
